'use client';

import { styled } from '@linaria/react';
import { RectangleSkeleton } from '@fe-common-ui/Skeleton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 16px 16px 16px;
  border-radius: 6px;
  background-color: #f6f8fc;
  position: relative;
`;

const Time = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: #848d97;
  margin-bottom: 16px;
`;

const Divide = styled.div`
  width: 2px;
  height: 16px;
  background-color: #e2e8f1;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: #848d97;

  span {
    font-size: 24px;
  }
`;

const Summary = styled.div`
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.71;
  text-align: justify;
  opacity: 0.9;
  color: #383838;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TagWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  column-gap: 6px;
`;

const RankingListHotPopTopicCardSkeleton = () => {
  return (
    <Container>
      <Time>
        <RectangleSkeleton width={80} height={18} />
        <Divide />
        <RectangleSkeleton width={18} height={18} />
      </Time>
      <TitleContainer>
        <RectangleSkeleton width={200} height={24} />
        <RectangleSkeleton width={64} height={28} />
      </TitleContainer>
      <Summary>
        <RectangleSkeleton width='100%' height={24} />
      </Summary>
      <TagWrapper>
        <RectangleSkeleton width={69} height={28} />
        <RectangleSkeleton width={69} height={28} />
        <RectangleSkeleton width={69} height={28} />
      </TagWrapper>
    </Container>
  );
};

export default RankingListHotPopTopicCardSkeleton;
